import React from 'react'
import { withSiteData, Link } from 'react-static'
import {
  Fragment,
  Flex,
  Box,
  Container,
  HeadingWithAnchor as Heading,
  Text,
  StaticText,
  Icon,
  Hr,
  A,
} from 'components'

const Footer = withSiteData(({ contact }) => (
  <Fragment>
    <Hr />
    <Container maxWidth="large">
      <Flex ml={-3} py={[2]} mb={[3, 4]} color="gray.0" flexWrap="wrap">
        <Box pl={3} mt={[4]} width={[1/2, 1/3, 1/4]}>
          <Heading my={0} is="h4">Contact</Heading>
          <Box mt={[2, 3]}><Icon mr={1} style={{ verticalAlign: 'bottom' }} name="twitter" /> <A href={`https://twitter.com/${contact.twitter}`} target="_blank">@{contact.twitter}</A></Box>
          <Box mt={[2, 3]}><Icon mr={1} style={{ verticalAlign: 'bottom' }} name="mail" /> <A href="mailto:dev@willhoag.com">{contact.email}</A></Box>
        </Box>
        <Box pl={3} mt={[4]} width={[1/2, 1/3, 1/4]}>
          <Heading my={0} is="h4">Sitemap</Heading>
          <Box mt={[2, 3]}><Link to="/">Home</Link></Box>
          <Box mt={[2, 3]}><Link to="/writing">Writing</Link></Box>
          <Box mt={[2, 3]}><Link to="/working">Work Together?</Link></Box>
        </Box>
        <Box pl={3} mt={[4]} width={[1/2, 1/3, 1/4]}>
          <Heading my={0} is="h4">Location</Heading>
          <Text mt={[2, 3]} is="p" fontSize={2} lineHeight={3}>
            <StaticText is="span" role="img" aria-label="heart" fontSize={4} lineHeight="1">🤘</StaticText> Based out of
            <br /><b style={{ display: 'inline-block' }}>Boulder, Colorado</b>
          </Text>
        </Box>
        <Box pl={3} mt={[4]} width={[1/2, 1/3, 1/4]}>
          <Heading my={0} is="h4">Details</Heading>
          <Text mt={[2, 3]} is="p" fontSize={2} lineHeight={3}>
            <b>&copy; Will Hoag</b> <span style={{ display: 'inline-block' }}>2015
            {new Date().getFullYear() > 2015 && `-${new Date().getFullYear()}`}</span>
          </Text>
        </Box>
      </Flex>
    </Container>
  </Fragment>
))

export default Footer



// WEBPACK FOOTER //
// /opt/build/repo/src/components/Footer.js